export default "__VITE_ASSET__BIN3vSou__"